export const buildEnvironment = {
"buildId":"120008",
"buildDate":"2022-06-29T08:03:12.852Z",
"buildTimeStamp":1656489792852,
"ngVersion":"9.1.4",
"version":"5.4.3744",
"api":"+19.11",
"environment":"prod",
"production":true
};